const API_URL = import.meta.env.VITE_API_URL || 'https://jdiaz-mc.jose-phase-one-ventures-projects.workers.dev';

class ApiService {
  async getHealth() {
    const res = await fetch(`${API_URL}/health`);
    return res.json();
  }

  async getTasks() {
    const res = await fetch(`${API_URL}/tasks`);
    return res.json();
  }

  async getActiveTasks() {
    const res = await fetch(`${API_URL}/tasks/active`);
    return res.json();
  }

  async getTask(id) {
    const res = await fetch(`${API_URL}/tasks/${id}`);
    return res.json();
  }

  async getStats() {
    const res = await fetch(`${API_URL}/stats`);
    return res.json();
  }

  async spawnTask(type, description, context = {}) {
    const res = await fetch(`${API_URL}/spawn`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, description, context }),
    });
    return res.json();
  }

  async updateTask(id, updates) {
    const res = await fetch(`${API_URL}/tasks/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates),
    });
    return res.json();
  }

  async runCheck() {
    const res = await fetch(`${API_URL}/check`, {
      method: 'POST',
    });
    return res.json();
  }
}

export const api = new ApiService();
